import app from "../main.js"

/**
 * @name can
 * @description Gets permissionId param like "readPolicies" and goes through
 * permission list from backend. Returns true if permission is in the list, false if it's not there.
 */
const can = (permissionId, userPermissions = []) => {
	// Get permissions from store
	userPermissions = app ? app.$store.state.permissions : []

	// Go through permissions and if permissionId is in the list return true
	return userPermissions.find(
		item => item.permission && item.permission.id === permissionId
	)
		? true
		: false
}

export { can }
